$(document).ready(function () {
  let detailSlider = $('.detail-slick');
  if (detailSlider.length) {
    detailSlider.slick({
      infinite: true,
      slidesToShow: 1,
      fade: true,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: true,
      prevArrow:
        "<button type='button' class='slick-prev'><svg class='slide-variants-detail--slider--arrow icon'><use xlink:href='/assets/build/img/symbol/icons.svg#chevron-left'></use></svg></button>",
      nextArrow:
        "<button type='button' class='slick-next'><svg class='slide-variants-detail--slider--arrow icon'><use xlink:href='/assets/build/img/symbol/icons.svg#chevron-right'></use></svg></button>",
      dots: true,
      dotsClass: 'custom_paging custom_paging--2',
      customPaging: function (slider, i) {
        if (i + 1 < 10) {
          if (slider.slideCount < 10) {
            return '0' + (i + 1) + '/0' + slider.slideCount;
          } else {
            return '0' + (i + 1) + '/' + slider.slideCount;
          }
        } else {
          return i + 1 + '/' + slider.slideCount;
        }
      },
    });
  }
});
